import {WinFieldController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinFieldController";
import {SanQuentin} from "../SanQuentin";
import {SanGameModuleConfig} from "../SanGameModuleConfig";

export class SanGameWinFieldController extends WinFieldController {

    public showWinField(to?: number, forceWin: boolean = false, forceTotalWin: boolean = false): void {
        if (this.shouldShow()) {
            to = to != null ? to : this._totalWin;
            const isWinBelow: boolean = SanGameModuleConfig.featurePrice.isWinBelowStake();

            if (!forceWin && (forceTotalWin || this._shouldShowTotalWin || this._shouldNextShowTotalWin)) {
                SanQuentin.keypad.setWin(to, true, isWinBelow);
                return;
            }
            SanQuentin.keypad.setWin(to, undefined, isWinBelow);
        }
    }
}